<template>
  <b-row>
    <b-col cols="12">
      <pop-orders-table />
    </b-col>
  </b-row>
</template>

<script>
import { BRow, BCol } from 'bootstrap-vue'
import PopOrdersTable from './PopOrdersTable.vue'

export default {
  components: {
    BRow,
    BCol,

    PopOrdersTable
  },
}
</script>

<style lang="scss" >
@import '@core/scss/vue/libs/vue-good-table.scss';
</style>